<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconRefresh_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M11.519 3.812c2.138 0 5.445 1.548 7.194 3l1.107-3.4a.606.606 0 0 1 1.18.205l-.045 6.529a.61.61 0 0 1-.61.607l-6.476-.045a.608.608 0 0 1-.596-.517.612.612 0 0 1 .41-.676l2.973-1.008.003.004.587-.201c-2.073-1.567-4.038-2.35-5.727-2.35-3.53 0-6.397 2.89-6.397 6.446 0 3.556 2.868 6.446 6.397 6.446a6.327 6.327 0 0 0 5.945-4.066l.032-.086.033-.093h.002l.204-.543a1.05 1.05 0 0 1 1.356-.617c.543.207.776.823.612 1.367l-.069.183C18.544 18.477 15.335 21 11.52 21 6.806 21 3 17.154 3 12.406c0-4.748 3.806-8.594 8.519-8.594Z"
    />
</svg>
